/*
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2023-02-03 17:48:55
 * @LastEditors: pj
 * @LastEditTime: 2023-02-16 18:26:13
 */
import { login_account, login_vcode, send_vcode } from '@/api/login'
import { user_info } from '@/api/user'

import { message } from 'ant-design-vue';
import storage from 'store'
import cookie from '@/utils/cookie'

const user = {
    state: () => ({
        token: null,
        user_info: {
        }
    }),
    // 设置属性状态
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USER: (state, user_info) => {
            state.user_info = user_info
        },
    },
    actions: {
        // nuxtServerInit ({ commit }, { app }) {
        //     let token = app.$cookies.get('ACCESS_TOKEN') ? app.$cookies.get('ACCESS_TOKEN') : '';
        //     commit('token', token);

        // },
        // 个人资料
        async get_user_info ({ commit, dispatch }, params) {
            if (!cookie.get('ACCESS_TOKEN')) {
                dispatch.Logout()
                return
            }
            let save_params = { dev_id: storage.get('dev_id') }
            return new Promise((resolve, reject) => {
                user_info(save_params).then((res) => {
                    if (res.code == 200) {
                        res.data.roles = [res.data.user_info.uname]
                        res.data.vip = res.data.vip_info.vip //vip  顶部显示
                        res.data.uname = res.data.user_info.uname //名字 顶部显示
                        commit('SET_USER', res.data)
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 账号登录
        async get_login_account ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                login_account(params).then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // 退出登录
        async Logout ({ commit, state }) {
            return new Promise((resolve) => {
                commit('SET_TOKEN', '')
                storage.remove('ACCESS_TOKEN')
                storage.remove('dev_id')
                storage.remove('user_info')
                cookie.remove('ACCESS_TOKEN')
                cookie.remove('dev_id')
                cookie.remove('user_info')
                commit('SET_USER', {})
                resolve()
            })
        },
        // 验证码登录
        async get_login_vcode ({ commit, state }, params) {
            return new Promise((resolve, reject) => {
                login_vcode(params).then((res) => {
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        //发送验证码
        async get_send_vcode ({ commit, state }, val) {
            return new Promise((resolve, reject) => {
                let params = { ...val, dev_id: storage.get('dev_id'), vcode_id: 101 }
                send_vcode(params).then((res) => {
                    if (res.code == 200) {
                        message.success('获取验证码成功')
                    } else {
                        message.error(res.msg)
                    }
                    resolve(res)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
};
export default user